/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext, useEffect, useState } from 'react';
import IEnergyManagementProps, {
  TrainingData
} from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import EmaasEnergyUsagesAllUtilityDetailWidget from './EmaasEnergyUsagesAllUtilityDetailWidget';
import useMounted from '../../../shared/useMount/useMount';
import useConnectorAndDynamicProps from '../../../shared/useConnectorAndDynamicProps/useConnectorAndDynamicProps';
import EmaasEnergyUsagesAllUtilitySavingsByMeter from './EmaasEnergyUsagesAllUtilitySavingByMeter';
import {
  getEnergyEndDateBasedOnSub,
  getEnergyStartDate
} from '../../../shared/Utils/EnergyUsagesViewDetailsUtils';
import { getIntervalType } from '../../../shared/Utils/PortfolioEnergy/PortfolioEnergyVDUtils';
import { EnergyUsageField } from '../../../shared/Enums';
import { EnergyUsageScopeType } from '../../../shared/Utils/Constants';
import { Icon } from '@scuf/common';
import moment from 'moment';
import EmaasBaselineFormModal from './EmaasBaselineFormModal';
import _ from 'lodash';
import { ApiContext } from '../../../../context/ApiContext';

const EmaasEnergyUsagesAllUtilitiesDetailsNILM = (
  props: IEnergyManagementProps
) => {
  const [t, lng] = useTranslation();
  const d = descriptors.energyManagement;
  const baselineIconCheck = true;
  const { bearerToken, requestContext, emaasContext } = props;
  const isMounted = useMounted();

  const startDate = getEnergyStartDate(
    requestContext.context.startTime!,
    requestContext.context.subscriptionType!,
    emaasContext
  );
  const endDate = getEnergyEndDateBasedOnSub(
    requestContext.context.subscriptionType!,
    requestContext.context.endTime!,
    requestContext.context.startTime!,
    emaasContext
  );
  const connectorConfig = {
    name: 'emaas-energy-Disaggregation',
    options: {
      startDate: startDate,
      endDate: endDate,
      allDetails: 'true',
      utilityType: EnergyUsageScopeType.ELECTRIC,
      intervalType: getIntervalType(startDate, endDate)
    }
  };

  useEffect(() => {
    if (isMounted) {
      dataConnector && dataConnector.actions && dataConnector.actions.getAll();
    }
  }, [requestContext]);

  const [dataConnector] = useConnectorAndDynamicProps({
    connectorConfig,
    requestContext,
    bearerToken
  });
  const [lastTrainedData, setLastTrainedData] = useState<TrainingData[]>([]);
  const { getBaselineTrainedData, pointHistoryUploadToggle } = useContext(
    ApiContext
  );
  const apiContext = useContext(ApiContext);
  const { selectedDateFormat, selectedTimeFormat } = apiContext;
  const fetchData = async () => {
    try {
      if (getBaselineTrainedData) {
        const res = await getBaselineTrainedData();
        const data = res.data;
        if (data) {
          setLastTrainedData(data);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [baselineIconCheck]);
  const lastBaseLineDate = baselineIconCheck
    ? _.maxBy(
        lastTrainedData.filter((e: { trainingStatus: string }) => {
          return e.trainingStatus === 'Completed';
        }),
        (e) => {
          return new Date(e.completedOn);
        }
      )?.completedOn
    : '';

  const [openModal, setOpenmodal] = useState<boolean>(false);

  return (
    <div className="all-utilities-details">
      <EmaasEnergyUsagesAllUtilityDetailWidget
        dataConnector={dataConnector}
        headerTitle={t(d.ENERGYPERFORMANCEALL)}
        nilmTab={EnergyUsageField.NILMENERGYUSAGE}
      />
      {baselineIconCheck && (
        <div className="pointHistoryUploadAreasSharedTab">
          {pointHistoryUploadToggle && (
            <span className="Meter-baseline-buttonNILM">
              {lastBaseLineDate && (
                <span className="baseline-date">
                  <Icon name="badge-check" root="common" color="green" />
                  {t(d.LAST_BASELINE_TRAINED_DATE)}{' '}
                  {/* {moment(lastBaseLineDate).format('ddd, DD MMM YYYY HH:mm')} */}
                  {moment(lastBaseLineDate)
                    .locale(lng)
                    .format(selectedDateFormat + ' ' + selectedTimeFormat)}
                </span>
              )}
              <Icon
                root="common"
                name="graph-drop"
                size="medium"
                onClick={() => setOpenmodal(true)}
              />
              <span
                className="button-content"
                style={{ padding: '0 10px' }}
                onClick={() => setOpenmodal(true)}
              >
                {t(d.baselinebutton)}
              </span>
            </span>
          )}
        </div>
      )}

      <EmaasEnergyUsagesAllUtilitySavingsByMeter
        nilmTab={EnergyUsageField.NILMENERGYUSAGE}
        dataConnector={dataConnector}
        subscriptionType={requestContext.context.subscriptionType!}
      />
      <EmaasBaselineFormModal
        setOpenmodal={setOpenmodal}
        bearerToken={bearerToken}
        requestContext={requestContext}
        openmodal={openModal}
      />
    </div>
  );
};
export default EmaasEnergyUsagesAllUtilitiesDetailsNILM;
